import { FaTimes } from 'react-icons/fa';

import styles from './modal-close-button.component.module.scss';

type Props = {
  onClose?: () => void;
};

/**
 * @deprecated Use `@findy-code/yuffie/ui` instead.
 */
export const LegacyModalCloseButton = ({ onClose }: Props) => {
  return (
    <button
      aria-label="閉じる"
      className={styles.modalCloseButton}
      type="button"
      onClick={onClose}
    >
      <FaTimes aria-hidden="true" size="1em" />
    </button>
  );
};
